import React, {useEffect} from 'react';

import Tooltip from '../components/Tooltip';
import Toggle from '../components/Toggle';
import Link from '../components/Link';

import {useAppContext, useAnalytics} from '../hooks';

const PREF_KEY = 'enableAIFeedbackPref';

export const getSavedAIFeedbackPref = () => {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem(PREF_KEY) === 'true';
};

export const setSavedAIFeedbackPref = (value) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(PREF_KEY, String(value));
  }
};

const DuetAIFeedbackToggle = ({value, onChange}) => {
  const {hasAiAccess} = useAppContext();
  const {tracker} = useAnalytics();

  useEffect(() => {
    tracker.duetViewAiFeedbackToggle();
  }, [tracker]);

  const handleToggle = (toggleOn) => {
    onChange(toggleOn);
    setSavedAIFeedbackPref(toggleOn);
    tracker.duetToggleAiFeedback({enabled: toggleOn});
  };

  return (
    <div className="flex p-4 bg-indigo-100 rounded-md justify-between items-center mb-4">
      <div className="flex flex-col">
        <div className="text-base font-semibold">Enable AI feedback</div>
        <div className="text-sm text-gray-800">
          {hasAiAccess ? (
            <>Receive a session transcript & AI-powered feedback.</>
          ) : (
            <>
              <Link href="/upgrade?src=practice" target="_blank" className="text-indigo font-medium">
                Upgrade
              </Link>
              {' '}
              for AI-powered session transcripts & feedback.
            </>
          )}
        </div>
      </div>
      <Tooltip
        content="Upgrade your account to unlock this feature"
        placement="top"
        disabled={hasAiAccess}
      >
        <div className="px-3">
          <Toggle
            onChange={handleToggle}
            disabled={!hasAiAccess}
            defaultOn={value}
          />
        </div>
      </Tooltip>
    </div>
  );
};

export default DuetAIFeedbackToggle;
